import Select from 'react-select';
/**
 * WordPress dependencies
 */
const { useState } = wp.element;
const { useSelect } = wp.data;

const EDDProductSelect = (props) => {
	const [searchKeyword, setSearchKeyword] = useState('');

	const { products, isRequesting } = useSelect(
		(select) => {
			const { isResolving } = select('core/data');

			const params = {
				per_page: 8,
				search: searchKeyword
			};

			return {
				products: select('core').getEntityRecords('postType', 'download', params),
				isRequesting: isResolving('core', 'getEntityRecords', ['postType', 'download', params])
			};
		},
		[searchKeyword]
	);

	const options =
		products?.map((product) => ({
			label: `${product.title.raw} (ID: ${product.id})`, // Assuming the title is rendered
			value: product.id
		})) || [];

	return (
		<div>
			<Select
				classNamePrefix='conditional-blocks-select'
				className='conditional-blocks-select-container'
				isSearchable
				isLoading={isRequesting}
				options={options}
				onInputChange={(val) => setSearchKeyword(val)}
				{...props}
			/>
		</div>
	);
};

export default EDDProductSelect;
